const characterImage = (path) => `/images/characters/${path}?v=20260712-1`;

const radiantSpriteOrders = new Set([
  'dustbringers',
  'edgedancers',
  'truthwatchers',
  'lightweavers',
  'elsecallers',
  'willshapers',
  'stonewards',
  'bondsmiths',
]);

const idealPositions = {
  2: 'left center',
  3: 'center center',
  4: 'right center',
};

export function buildRadiantPortrait(order, ideal) {
  const slug = order.id.replace('order-', '');
  const label = `${order.name} at the ${ideal === 2 ? 'Second' : ideal === 3 ? 'Third' : 'Fourth'} Ideal`;

  if (radiantSpriteOrders.has(slug)) {
    return {
      src: characterImage(`radiants/${slug}-ideals.png`),
      label,
      spritePosition: idealPositions[ideal],
    };
  }

  return {
    src: characterImage(`radiants/${slug}-ideal-${ideal}.png`),
    label,
  };
}

const mistbornPortraits = [
  { label: 'Elend Venture as a Mistborn', spritePosition: 'left center' },
  { label: 'Vin as a Mistborn', spritePosition: 'center center' },
  { label: 'A Mistborn in the mists', spritePosition: 'right center' },
];

const feruchemistPortraits = [
  { label: 'Sazed carrying his metalminds', spritePosition: 'left center' },
  { label: 'A traveling Feruchemist with her metalminds', spritePosition: 'center center' },
  { label: 'A Feruchemist scholar with his metalminds', spritePosition: 'right center' },
];

function pickPortrait(portraits, variant, src) {
  return {
    ...portraits[variant % portraits.length],
    src: characterImage(src),
  };
}

export function buildMistbornPortrait(variant) {
  return pickPortrait(mistbornPortraits, variant, 'metalborn/mistborn-portraits.png');
}

export function buildFeruchemistPortrait(variant, { includeSazed = true } = {}) {
  const portraits = includeSazed ? feruchemistPortraits : feruchemistPortraits.slice(1);
  return pickPortrait(portraits, variant, 'metalborn/feruchemist-portraits.png');
}
